import * as React from "react";
const SvgFiRrPickaxe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pickaxe_svg__a)">
      <path
        fill="#062147"
        d="M22.867 18.985c-.515 0-.946-.36-1.067-.862-.809-3.356-2.643-6.666-5.092-9.418l-15 15.002a.997.997 0 0 1-1.415 0 1 1 0 0 1 0-1.414L15.295 7.29c-2.755-2.456-6.07-4.296-9.434-5.106A1.105 1.105 0 0 1 5 1.117 1.096 1.096 0 0 1 6.12.02c5.168.182 9.265 1.637 12.228 4.218l.945-.945a.999.999 0 1 1 1.414 1.414l-.946.946c2.572 2.962 4.022 7.054 4.204 12.213a1.093 1.093 0 0 1-1.098 1.12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pickaxe_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPickaxe;
